module.exports = __webpack_public_path__ + "static/media/ballard_park.56f46bfd.png";